const BaseUrl = process.env.REACT_APP_API_BaseUrl;
// const BaseUrl = 'https://lorriapitest.azurewebsites.net'
// const BaseUrl = 'https://apilorri.azurewebsites.net'
const ProfileBaseUrl = process.env.REACT_APP_API_Profile_BaseUrl;
const FileUrl=process.env.REACT_APP_API_FileUrl
const lorriApplicationService = process.env.REACT_APP_APPLICATION_SERVICE_URL
export const Urls = {
  Transporters: {
    GetAll: `${BaseUrl}/api/apilorri/transporter_search`,
    Get: `${ProfileBaseUrl}/api/apiuser/transporter_details`,
    Recommend:
      // `https://vendorcreation.azurewebsites.net/api/recommend_transporter`,
      `${BaseUrl}/api/apilorri/recommend_transporter`,
    UpdateTransporter:
      // `https://vendorcreation.azurewebsites.net/api/transporter`,
      `${BaseUrl}/api/apilorri/transporter`,
    SendgridEmail: `${BaseUrl}/api/apilorri/trigger_email`,
    SmtpEmail: `${BaseUrl}/api/apilorri/trigger_email`,

    GetUserDetails: `${BaseUrl}/api/apilorri/user_details`,
    GetMyTransporters: `${BaseUrl}/api/apilorri/my_transporters`,
    Rating: `${BaseUrl}/api/apilorri/rating`,
    Delete: `${BaseUrl}/api/apilorri/transporterlist_edit`,
    GetSimilarTransporter: `${BaseUrl}/api/apilorri/similar-transporters`,
    Shortlist: `${BaseUrl}/api/apilorri/shortlists `,
    mailservice: `https://smtpemailservice.azurewebsites.net/api/Email_Service?code=/niHyaTO0jFc9sVjBdDgRKkLdWi23SKgE62yl5whBJXXaXWaJZsOfw==`
  },

  Users: {
    GetCurrentUser: `${BaseUrl}/api/apilorri/user_details`
  },
  References: {
    Save: `${BaseUrl}/api/apilorri/post_referrals`
  },
  VAS: {
    Save: `${BaseUrl}/api/apilorri/post_value_added_services`
  },
  User: {
    Get: {
      ServicesAndReferrals: `${BaseUrl}/api/apilorri/get_value_added_services_referrals`
    },
    Post: {
      Referral: `${BaseUrl}/api/apilorri/post_value_added_services_referrals`
    }
  },
  Autocomplete: {
    Get: {
      getlist: `${BaseUrl}/api/apilorri/autocomplete`
    }
  },
  MyAccount: {
    Get: {
      RatedTransporters: `${BaseUrl}/api/apilorri/rated-transporters`,
      ShortlistedTransporters: `${BaseUrl}/api/apilorri/shortlists`,
      ReferalsAndVAS: `${BaseUrl}/api/apilorri/get_value_added_services_referrals`
    }
  },
  template: 'https://lndocs.blob.core.windows.net/transpporterlogo/index.html',
  ipinfo: `https://cors-anywhere.herokuapp.com/https://api.ipify.org/?format=json`,
  globe: 'https://adhoclorri.azurewebsites.net/api/geocoderapi',
  globeget: 'https://adhoclorri.azurewebsites.net/api/coordinates',
  azureSearch: 'https://networksearch.search.windows.net/indexes/location-index/docs?api-version=2019-05-06&search=*&$top=1000',
  locationapi: `${BaseUrl}/api/apilorri/location-analysisv2?code=403uUoAMJkkEU69D8NsM0jCVxKFfvON0ROo4uLEnJQY9YfX4/9ursg==`,
  blobUrl: 'https://blobfileupload.azurewebsites.net/api/blobfile',
  services: {
    GET: `https://genericfeatures.azurewebsites.net/api/get_services`,
    POST: `https://genericfeatures.azurewebsites.net/api/post_services`
  },
  CompareUrl: `${BaseUrl}/api/apilorri/transporter-comparison`,
  logURL: `${BaseUrl}/api/apilorri/log`,
  user_data: `${BaseUrl}/api/apilorri/user`,
  DiscoverNow: `${BaseUrl}/api/apilorri/search/transporters`,
  fileUploadService: ` https://fileuploadservice.azurewebsites.net/api/${FileUrl}`,
  getActiveprocurement:`${BaseUrl}/api/apilorri/procurements/`,
  fileService: `${lorriApplicationService}/api/fileupload`
};
